/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type EmployeeUsedApplicationsQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['UUID']['input'];
  applicationName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type EmployeeUsedApplicationsQuery = { __typename: 'Query', clientEmployeeApplicationInteractions?: { __typename: 'ClientEmployeeApplicationInteractionsResultType', filteredCount: number, interactions: Array<{ __typename: 'ClientEmployeeApplicationInteractionType', primaryResource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, vendorName?: string | null } }> } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const EmployeeUsedApplicationsDocument = new TypedDocumentString(`
    query EmployeeUsedApplications($employeeId: UUID!, $applicationName: String, $offset: Int, $limit: Int) {
  clientEmployeeApplicationInteractions(
    clientEmployeeId: $employeeId
    applicationName: $applicationName
    orderBy: "name"
    offset: $offset
    limit: $limit
  ) {
    filteredCount
    interactions {
      primaryResource {
        id
        productName
        vendorName
      }
    }
  }
}
    `);

export const useEmployeeUsedApplicationsQuery = <
      TData = EmployeeUsedApplicationsQuery,
      TError = unknown
    >(
      variables: EmployeeUsedApplicationsQueryVariables,
      options?: Omit<UseQueryOptions<EmployeeUsedApplicationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EmployeeUsedApplicationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EmployeeUsedApplicationsQuery, TError, TData>(
      {
    queryKey: ['EmployeeUsedApplications', variables],
    queryFn: fetcher<EmployeeUsedApplicationsQuery, EmployeeUsedApplicationsQueryVariables>(EmployeeUsedApplicationsDocument, variables),
    ...options
  }
    )};

useEmployeeUsedApplicationsQuery.getKey = (variables: EmployeeUsedApplicationsQueryVariables) => ['EmployeeUsedApplications', variables];

export const useInfiniteEmployeeUsedApplicationsQuery = <
      TData = InfiniteData<EmployeeUsedApplicationsQuery>,
      TError = unknown
    >(
      variables: EmployeeUsedApplicationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EmployeeUsedApplicationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EmployeeUsedApplicationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<EmployeeUsedApplicationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EmployeeUsedApplications.infinite', variables],
      queryFn: (metaData) => fetcher<EmployeeUsedApplicationsQuery, EmployeeUsedApplicationsQueryVariables>(EmployeeUsedApplicationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteEmployeeUsedApplicationsQuery.getKey = (variables: EmployeeUsedApplicationsQueryVariables) => ['EmployeeUsedApplications.infinite', variables];


useEmployeeUsedApplicationsQuery.fetcher = (variables: EmployeeUsedApplicationsQueryVariables) => fetcher<EmployeeUsedApplicationsQuery, EmployeeUsedApplicationsQueryVariables>(EmployeeUsedApplicationsDocument, variables);
